<style lang="scss" scoped>
.modal-desc {
    padding: 20px 0;
    text-align: center;
    font-size: 13px;
}
.modal-button {
    float: right;
}
</style>
<template>
	<section class="margin-15">
		<template v-if="type==='query'">
			<aside class="text-right">
				<vButton v-if="isCanBoxing" class="margin-right-15" theme="error" @click="goBoxing">{{$t('fbb.alloment.button_go_boxing', { defaultValue: '装箱' })}}</vButton>
				<vButton class="margin-right-15" theme="info" @click="handleModal('deliver')">{{$t('fbb.alloment.query_send_detail', { defaultValue: '查看发货详情' })}}</vButton>
				<vButton class="margin-right-15" theme="warning" @click="handleModal('boxing')">{{$t('fbb.inbound.seebox', { defaultValue: '查看装箱' })}}</vButton>
				<vButton class="margin-right-15" theme="success" @click="handleDownload('product')">{{$t('fbb.alloment.export_detail', { defaultValue: '导出明细' })}}</vButton>
				<vButton class="margin-right-15" theme="primary" @click="handleDownload('boxing')">{{$t('fbb.alloment.export_go_boxing_detail', { defaultValue: '导出装箱明细' })}}</vButton>
			</aside>
			<span>
				{{$t('fbb.alloment.total_sku_total', { defaultValue: '总计：SKU种数合计：' })}}{{dataList.length}}&nbsp;&nbsp;
				{{$t('fbb.alloment.total_plan_qty', { defaultValue: '计划出库数量总计：' })}}{{dataList|handleTotalDataList('qty')}}&nbsp;&nbsp;
				{{$t('fbb.alloment.total_out_bound_qty', { defaultValue: '实际出库数量总计：' })}}{{dataList|handleTotalDataList('qtyOutbound')}}&nbsp;&nbsp;
				{{$t('fbb.alloment.total_receive_qty', { defaultValue: '实际接收数量总计：' })}}{{dataList|handleTotalDataList('qtyInbound')}}&nbsp;&nbsp;
			</span>
		</template>
		<template v-else>
			<vFormItem label-width="100" inline label="ERP SKU:" class="margin-bottom-10">
				<vInput v-model="formData.erpSku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
			</vFormItem>
			<vFormItem label-width="100" inline :label="$t('fbb.alloment.inventory_available', { defaultValue: '可用库存' }) + ':'">
				<span>{{formData.qty!==''?formData.qty:'-'}}</span>
			</vFormItem>
			<vFormItem label-width="100" inline :label="$t('fbb.alloment.out_bound_number', { defaultValue: '出库数量' }) + ':'">
				<vInputNumber clearable v-model="formData.outPlanqty" :min="1"/>
			</vFormItem>
			<vButton theme="primary" class="margin-left-10" @click="addItem(formData)">{{$t('fbb.alloment.add_by_one', { defaultValue: '逐个添加' })}}</vButton>
			<vButton theme="info" class="margin-left-10" @click="handleUploadData">{{$t('fbb.alloment.muti_import', { defaultValue: '批量导入' })}}</vButton>
			<aside>
				<vButton class="margin-right-10" theme="gray" @click="clearAll">{{$t('global.common.clear', { defaultValue: '清空所有' })}}</vButton>
				{{$t('fbb.alloment.total_sku_total', { defaultValue: '总计：SKU种数合计：'})}}{{dataList.length}}&nbsp;&nbsp;
				{{$t('fbb.alloment.total_out_bound', { defaultValue: '出库总数量：' })}}{{dataList|handleTotalDataList}}
			</aside>
		</template>
		<vTableSimple class="margin-top-10" :columns="columns" :data="dataList"></vTableSimple>
		<vModal
			v-model="modalProps.show"
			:title="modalProps.title"
			:width="modalProps.width||1000"
			:showFooter="false"
		>
			<component
				:is="modalProps.component"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
				v-bind="modalProps.props"
			></component>
		</vModal>
	<compModal
            v-model="modalProps2.show"
            v-bind="modalProps2"
            @on-close="modalProps2.show = false"
            @on-confirm="modalProps2.show = false"
        >
            <div class="clearfix" v-if="modalProps2.showConfirm">
                <div class="modal-desc">{{ modalProps2.desc }}</div>
                <div class="modal-button">
                    <Button
                        class="margin-right-15"
                        type="primary"
                        @click="modalProps2.confirm"
                        >{{$t('global.common.confirm', { defaultValue: '确定' })}}</Button
                    >
                    <Button type="default" @click="modalProps2.show = false"
                        >{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</Button
                    >
                </div>
            </div>
            <component
                v-if="modalProps2.component"
                :is="modalProps2.component"
                v-bind="modalProps2.props"
                @on-close="modalProps2.show = false"
                @on-success="modalSuccess"
                v-on="modalProps2.on"
            />
        </compModal>
	</section>
</template>

<script>
import { HttpPlanBillErpSku,HttpSubManageBillList,HttpRetryWms } from '@/service/allotment';
import compErpsku from './erpsku'
import compDeliver from './deliverdetail';
import compBoxing from './boxingdetail';
export default {
	props: ['data', 'baseData','warehouseType'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compDeliver,
		compBoxing,
		compErpsku
	},
/* 	created() {
		if(this.isManageBill){
			HttpSubManageBillList({
				"search[EQ_id]":this.id 
			}).then(res => {
				this.sonId = this.$route.query.id;
				this.id = res.data.content[0].headId;
			})
		}
    
  }, */
	data() {
		return {
			type: this.$route.params.type,
			name: this.$route.name,
			id:this.$route.query.id,
			formData: {
				
			},
			dataList: this.data || [],
			erpSkuData: {},
			modalProps: {
				show: false,
				title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
				component: "",
				width: 1000,
				props: {},
				on: {},
			},
			modalProps2: {
				show: false,
				width: 600,
				props: {},
				on: {},
			}
		}
	},
	watch: {
		data(val) {
			this.dataList = val;
		},
	},
	computed: {

isManageBill() {
			return this.$route.name === 'allotUpdateManage' || this.$route.name === "allotManageBill"
		},
		columns() {
			return this.type !== 'query' ? [{
				title: "ERP SKU",
				key: 'sku'
			}, {
				title: this.$t('fbb.alloment.out_bound_number', { defaultValue: "出库数量" }),
				key: 'qty'
			}, {
				title: this.$t('global.common.operation', { defaultValue: '操作' }),
				align: 'center',
				render: (h, { index }) => {
					return <vButton theme="error" nativeOnClick={this.removeItem.bind(this, index)}>{this.$t('global.common.delete', { defaultValue: '删除' })}</vButton>
				}
			}] :
				[{
					title: "ERP SKU",
					key: 'sku'
				}, {
					title: this.$t('fbb.inbound.planned_quantity', { defaultValue: "计划数量" }),
					key: 'qty'
				}, {
					title: this.$t('fbb.alloment.has_boxing', { defaultValue: "已装箱数量" }),
					key: "qtyPacked",
				}, {
					title: this.$t('fbb.alloment.actual_out_bound', { defaultValue: "实际出库数量" }),
					key: 'qtyOutbound'
				}, {
					title: this.$t('fbb.alloment.actual_in_bound', { defaultValue: "实际入库数量" }),
					key: 'qtyInbound'
				}, {
					title: this.$t('fbb.alloment.recent_update_time', { defaultValue: "最近更新时间" }),
					key: 'updatedAt'
				}]
		}
	},
	filters: {
		handleTotalDataList(data = [], type = "qty") {
			let total = 0;
			data.forEach(item => {
				total += item[type];
			});
			return total;
		},
	},
	methods: {
		// 详情操作
		handleModal(type) {
			if (type === 'deliver') {
				this.modalProps = {
					show: true,
					title: this.$t('fbb.alloment.query_send_detail', { defaultValue: '查看发货详情' }),
					component: "compDeliver",
					props: {
						initFormData: {
							id: this.id,
							isManage:this.isManageBill ? 0 : 1
						},
						startUp:true,
					}
				}
				return;
			}
			if (type === 'boxing') {
				this.modalProps = {
					show: true,
					title: this.$t('fbb.inbound.seebox_detail', { defaultValue: '查看装箱详情' }),
					component: "compBoxing",
					props: {
						initFormData: {
							id:this.isManageBill ? this.baseData.headId : this.id,
						},
						startUp:true,
					}
				}
				return;
			}
			
		},
		handleDownload(type) {
			const urlMap = {
				'product': '/api/v2/TransferOutboundPlanItem/batchExport',
				'boxing': '/api/v2/TransferOutboundPlanBoxItem/exportPackages',
			}
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + urlMap[type], { id: this.isManageBill ? this.baseData.headId : this.id, }, 'download');
		},
		//装箱
		handleSkuErp() {
			const { lineId, orgWarehouseId, inventoryType } = this.baseData;
			const hasOrgWarehouse = orgWarehouseId || orgWarehouseId == '0';
			if (!lineId || !hasOrgWarehouse) return this.$VMessage.warning(this.$t('fbb.alloment.fill_line_and_warehouse', { defaultValue: '请填写项目和仓库' }));
			this.modalProps = {
				show: true,
				title: this.$t('fbb.alloment.choose_product', { defaultValue: '选择产品' }),
				component: "compErpsku",
				props: {
					initFormData: {
						'search[EQ_inventoryType]': inventoryType,
						'search[EQ_orgWarehouseId]':  orgWarehouseId == 0?'':orgWarehouseId,
						'lineId': lineId,
						'search[EQ_organizationId]': global.SYSID,
					}
				},
				on: {
					'on-data': (row) => {
						this.formData = Object.assign(this.formData, row, { erpSku: row.sku });
						if(this.warehouseType==0||this.warehouseType==2||this.warehouseType==4){
							this.formData.qty=undefined
						}
						this.modalProps.show = false;
					}
				},
			}
		},
		//上传数据
		handleUploadData() {
			const { orgWarehouseId, inventoryType,lineId } = this.baseData;
			const hasOrgWarehouse = orgWarehouseId || orgWarehouseId == '0';
			if (!hasOrgWarehouse) return this.$VMessage.warning(this.$t('fbb.alloment.fill_warehouse_and_warehouse_type',{ defaultValue: '请先填写仓库和仓库类型' }));
			this.modalProps = {
				show: true,
				title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
				component: "compUpload",
				width: 520,
				props: {
					data: { orgWarehouseId, inventoryType,lineId },
					action: process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlanItem/batchImport",
					name: "excelFile",
					download: () => {
						this.handleWebfs("/static/template/Transfer_Outbound_Plan_Items.xlsx", {}, {
							executor: 'download',
							type: 'url'
						});
						// this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlanItem/transferOutboundPlanItemTemplate", 'download')
					},
				},
				on: {
					'on-success': (row) => {
						row.data.forEach((item) => {
							this.addItem({ outPlanqty: item.qty, sku: item.sku });
						})
						this.modalProps.show = false;
					}
				},
			}
		},
		addItem(data) {
			const { sku, outPlanqty } = data;
			if (sku && outPlanqty) {
				const erpSkuData = this.dataList.find((item) => {
					return item.sku === sku
				});
				if (erpSkuData) {
					erpSkuData.qty += outPlanqty;
					// if (erpSkuData.qty > qty) erpSkuData.qty = qty;
				} else {
					this.dataList.push({ sku, qty: outPlanqty })
				}
				this.formData = { qty: '' };
				return;
			}
			this.$VMessage.warning(this.$t('fbb.alloment.fil_sku_and_outbound_number', { defaultValue: '请填写ERP SKU和出库数量' }));
		},
		clearAll() {
				this.modalProps2={
                    show: true,//显示弹框
					showConfirm:true,
                    desc: this.$t('fbb.alloment.confirm_clear_all_data', { defaultValue: '是否确认清空所有数据？' }),
					title: this.$t('global.common.clear', { defaultValue: '清空' }),//标题，
					showFooter:false,
					confirm: ()=>{
						this.dataList = [];
						this.modalProps2.show=false;
					}
                   
                };
			
		},
		removeItem(index) {
			this.dataList.splice(index, 1)
		},
		// 可以装箱
		isCanBoxing() {
			const transferOutboundPlanStatus = this.baseData.transferOutboundPlanStatus;
			return this.$route.name === 'allotUpdateManage' && (transferOutboundPlanStatus == 0 || transferOutboundPlanStatus == 5 || transferOutboundPlanStatus == 10 || transferOutboundPlanStatus == 15)
		},
		// 管理单据页面
		goBoxing() {
			this.$router.push({
				name: 'allotEncase',
				query: {
					id: this.isManageBill ? this.baseData.headId : this.id,
					type:this.isManageBill,
					sonId : this.id,
					transferOutboundPlanNo: this.baseData.transferOutboundPlanNo,
					labelCreateStatus: this.baseData.labelCreateStatus
				},
				params: {
					type: 'edit'
				}
			})
		},
		

	}
}
</script>